/**
 * System announcement items attached to the selected role after
 * POST /api/change_role (Angular `selectedCurrentUserRole.notification`).
 */
export interface RoleSystemAnnouncement {
  sa_id: number
  announcement_topic: string
  announcement_description?: string
  start_date?: string
  end_date?: string
  show_effective_dates?: '0' | '1' | 0 | 1 | boolean | string | number
  /** Session flag — Angular sets to `'1'` when the popup has been opened. */
  isshown?: '0' | '1' | 0 | 1 | boolean | string | number
}

export function isAnnouncementShown(announcement: RoleSystemAnnouncement): boolean {
  return announcement.isshown === '1' || announcement.isshown === 1 || announcement.isshown === true
}

export function shouldShowEffectiveDates(announcement: RoleSystemAnnouncement): boolean {
  return (
    announcement.show_effective_dates === '1' ||
    announcement.show_effective_dates === 1 ||
    announcement.show_effective_dates === true
  )
}
